// Blog post categories
export enum BlogCategory {
  DIGITAL_TRANSFORMATION = 'digital_transformation',
  CLOUD_SOLUTIONS = 'cloud_solutions',
  ARTIFICIAL_INTELLIGENCE = 'artificial_intelligence',
  CYBERSECURITY = 'cybersecurity',
  SOFTWARE_DEVELOPMENT = 'software_development',
  IT_CONSULTING = 'it_consulting',
}

// Blog post status
export enum BlogPostStatus {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
}

export interface BlogPost {
  id: string;
  slug: string;
  titleTR: string;
  titleEN: string;
  excerptTR: string;
  excerptEN: string;
  contentTR: string;
  contentEN: string;
  category: BlogCategory;
  tags: string[];
  featuredImage: string;
  publishDate: string;
  readTime: number;
  author: {
    name: string;
    avatar: string;
  };
  status: BlogPostStatus;
}